<template>
  <labelable
    ref="labelableComponent"
    v-on="$listeners"
    v-bind="$attrs"
    :is-selected="objectModelAction.isSelected"
    v-model="objectModelAction.label_title"
    placeholder="Enter action name..."></labelable>
</template>

<script lang="ts">
  import Vue from "vue";
  import Labelable from "../../../common/components/modelProperties/labelable.vue";
  import ObjectModelAction from "../../../common/models/objectModelActions/objectModelAction";

  export default Vue.extend({
    inheritAttrs: false,
    components: {Labelable},
    props: {
      objectModelAction: {
        type: Object as () => ObjectModelAction,
        required: true
      },
    },
    data: function () {
      return {};
    },
    methods: {
      enableEditMode() {
        this.$refs.labelableComponent.enableEditMode();
      }
    }
  });
</script>
